/* import __COLOCATED_TEMPLATE__ from './dropdown-select-box-row.hbs.js'; */
import { readOnly } from "@ember/object/computed";
import { classNames } from "@ember-decorators/component";
import SelectKitRowComponent from "select-kit/components/select-kit/select-kit-row";
const DropdownSelectBoxRow = dt7948.c(class DropdownSelectBoxRow extends SelectKitRowComponent {
  static {
    dt7948.g(this.prototype, "description", [readOnly("item.description")]);
  }
  #description = (dt7948.i(this, "description"), void 0);
}, [classNames("dropdown-select-box-row")]);
export default DropdownSelectBoxRow;